import { beforeUnloadConfirmationText } from './beforeUnloadHandler.locstring.json';
import loc from 'owa-localize';
import { isViewStateDirty } from './viewStateUtils';
import { ComposeViewState, AsyncSendState } from 'owa-mail-compose-store';

const BEFORE_UNLOAD_EVENT = 'beforeunload';
const activeViewStates: ComposeViewState[] = [];
let beforeUnloadHandlerAdded = false;

function onBeforeUnload(ev: BeforeUnloadEvent) {
    for (const viewState of activeViewStates) {
        // VSO 35426: Warn user if they are trying to close out of the browser
        // during delayed send, since the send has not yet actually happened
        if (isViewStateDirty(viewState) || viewState.asyncSendState === AsyncSendState.Delay) {
            ev.returnValue = loc(beforeUnloadConfirmationText);
            break;
        }
    }
}

export function addViewStateToBeforeUnloadHandler(viewState: ComposeViewState) {
    if (activeViewStates.indexOf(viewState) < 0) {
        activeViewStates.push(viewState);

        if (!beforeUnloadHandlerAdded) {
            window.addEventListener(BEFORE_UNLOAD_EVENT, onBeforeUnload);
            beforeUnloadHandlerAdded = true;
        }
    }
}

export function removeViewStateFromBeforeUnloadHandler(viewState: ComposeViewState) {
    const index = activeViewStates.indexOf(viewState);

    if (index >= 0) {
        activeViewStates.splice(index, 1);

        if (activeViewStates.length == 0 && beforeUnloadHandlerAdded) {
            window.removeEventListener(BEFORE_UNLOAD_EVENT, onBeforeUnload);
            beforeUnloadHandlerAdded = false;
        }
    }
}
